import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import { getUserSubscriptionById } from 'helpers/fakebackend_helper';
import { Badge } from 'reactstrap';

const SubscriptionStatusBadge = ({ userId }) => {
    const { data: subscriptionData, isLoading, error } = useQuery(
        ['user_subscription_badge', userId],
        () => getUserSubscriptionById(userId),
        {
            enabled: !!userId,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5 minutes
        }
    );

    if (isLoading) {
        return <Badge color="secondary">Loading...</Badge>;
    }

    if (error) {
        return <Badge color="danger">Error</Badge>;
    }

    if (!subscriptionData?.has_subscription) {
        return <Badge color="danger">No Subscription</Badge>;
    }

    const { subscription, is_trial } = subscriptionData;

    if (is_trial) {
        return (
            <div>
                <Badge color="warning">Trial</Badge>
                {subscription?.trial_ends_at && (
                    <div className="small text-muted mt-1">
                        Until {new Date(subscription.trial_ends_at).toLocaleDateString()}
                    </div>
                )}
            </div>
        );
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'active':
                return 'success';
            case 'trialing':
                return 'warning';
            case 'canceled':
                return 'danger';
            case 'past_due':
                return 'danger';
            case 'incomplete':
                return 'secondary';
            default:
                return 'secondary';
        }
    };

    return (
        <div>
            <Badge color={getStatusColor(subscription?.status)}>
                {subscription?.status?.charAt(0).toUpperCase() + subscription?.status?.slice(1)}
            </Badge>
            {subscription?.current_period_end && (
                <div className="small text-muted mt-1">
                    Until {new Date(subscription.current_period_end).toLocaleDateString()}
                </div>
            )}
        </div>
    );
};

SubscriptionStatusBadge.propTypes = {
    userId: PropTypes.number.isRequired,
};

export default SubscriptionStatusBadge;
